<template>
    <v-form ref="vueForm">
        <v-container>
            <v-row>
                <v-col sm="12" md="4" offset-md="4" style="margin-top:10%">
                    <v-card elevation="10" class="rounded-lg mx-auto" style="background-color: #FFFFFF ">
                        <v-img max-height="150" max-width="200" src="/images/selu-produccion.png" class="mx-auto my-4"></v-img>
                        <v-card-title class="text-center" style="color: #CCA687">Accesos</v-card-title>

                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="form" v-model="valid" @submit.prevent="onClickIniciarSesion">
                                <v-text-field variant="outlined"
                                              :label="jsglobals.Usuario"
                                              type="text"
                                              maxlength="100"
                                              autocomplete="on"
                                              :style="{ backgroundColor: 'white' }"
                                              :rules="[vrules.required]"
                                              v-model="usuario">
                                </v-text-field>
                                <v-text-field v-model="password"
                                              :type="show1 ? 'text' : 'password'"
                                              :label="jsglobals.Password"
                                              variant="outlined"
                                              maxlength="100"
                                              hide-details
                                              autocomplete="on"
                                              :style="{ backgroundColor: 'white' }"
                                              @keyup.enter="onClickIniciarSesion">
                                    <template #append-inner>
                                        <v-icon @click="show1 = !show1"
                                                class="cursor-pointer">
                                            {{ show1 ? 'mdi-eye' : 'mdi-eye-off' }}
                                        </v-icon>
                                    </template>
                                </v-text-field>
                                <div class="text-center mt-3">
                                    <a style="color: #CCA687; cursor: pointer; text-decoration: underline;"
                                       @click="onClickOlvidoPassword">
                                        <template v-if="!loading">
                                            {{ jsglobals.LabelOlvidoPassword }}
                                        </template>
                                        <template v-else>
                                            <v-progress-circular indeterminate size="16" width="2" color="#CCA687" />
                                        </template>
                                    </a>
                                </div>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-text class="text-center">
                            <v-btn rounded
                                   x-large
                                   color="accent"
                                   :loading="loading"
                                   :disabled="loading || !valid"
                                   @click="onClickIniciarSesion">
                                <v-icon left>mdi-lock</v-icon>
                                {{ jsglobals.Ingresar }}
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>
<script setup>
    import { useLoginStore } from '../../../wwwroot/stores/account/loginStore'
    import { storeToRefs } from 'pinia'
    import { inject, ref, watch } from 'vue'

    import ChangePassword from '../../../componentes/Account/ChangePassword/account-change-password.vue'
    import PasswordRecovery from '../../../componentes/Account/PasswordRecovery/account-password-recovery.vue'
    import RequestPasswordRecovery from '../../../componentes/Account/RequestPasswordRecovery/account-request-password-recovery.vue'

    // Props
    const props = defineProps({
        model: {
            type: Object,
            default: () => ({})
        }
    });

    // Inyecciones
    const vrules = inject('vrules');
    const jsglobals = inject('jsglobals');
    const notify = app.config.globalProperties.$notify;
    const defaultErrorHandler = inject('defaultErrorHandler');
    const clearErrors = inject('clearErrors');

    // Store
    const store = useLoginStore();
    const { usuario, password, id_app, form, loading, valid } = storeToRefs(store);
    const { onClickIniciarSesion, onClickOlvidoPassword } = store;
    const show1 = ref(false);

    watch(() => props.model, (model) => {
        if (model?.Usuario) {
            usuario.value = model.Usuario;
        }
    }, { immediate: true });
</script>


